import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift, CheckCircle2, Sparkles } from 'lucide-react';
interface PremiumBonus {
  image: string;
  alt: string;
  badge: string;
  title: string;
  description: string;
  features: string[];
  value: string;
}
export function PremiumBonuses() {
  const bonuses: PremiumBonus[] = [{
    image: 'https://cdn.magicpatterns.com/uploads/weUWBRP79Et4u4A3nw3eHC/Bono_1_FBM.png',
    alt: 'Bono 1: Guía Rápida para Envíos FBM',
    badge: 'BONO PREMIUM #1',
    title: 'GUÍA RÁPIDA PARA ENVÍOS FBM Y CÓMO PAGAR MENOS EN TUS ENVÍOS',
    description: 'Aprende a reducir costos, evitar errores y aumentar tus ganancias en cada envío que realices con Amazon FBM.',
    features: ['Calcula correctamente tus costos de envío', 'Elige el mejor transportista (USPS, UPS, FedEx)', 'Ahorra dinero en cada paquete enviado', 'Evita errores comunes que hacen perder ganancias'],
    value: '$47'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/5DYGsuT9qcsTwwY4NQaVcN/bono_2_FBM.png',
    alt: 'Bono 2: Campañas Publicitarias en Amazon Seller para FBM',
    badge: 'BONO PREMIUM #2',
    title: 'CÓMO HACER CAMPAÑAS PUBLICITARIAS EN AMAZON SELLER PARA FBM',
    description: 'Aumenta la visibilidad de tus productos, atrae más compradores y multiplica tus ventas con campañas bien configuradas.',
    features: ['Investigación de palabras clave que venden', 'Configuración correcta de campañas', 'Optimización para reducir costos por clic', 'Análisis de resultados y escalado'],
    value: '$57'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/94TssJWnJ1s5LhgkvacSQn/bono_3_FBM.png',
    alt: 'Bono 3: Guía Completa para Conseguir Proveedores y Productos FBM',
    badge: 'BONO PREMIUM #3',
    title: 'GUÍA COMPLETA PARA CONSEGUIR PROVEEDORES Y PRODUCTOS PARA VENDER EN AMAZON FBM',
    description: 'Encuentra productos rentables, negocia mejores precios y construye tu negocio desde cero con bases sólidas.',
    features: ['Investiga productos con alta demanda', 'Analiza la competencia y rentabilidad', 'Valida productos antes de invertir', 'Negocia precios y condiciones con proveedores'],
    value: '$67'
  }];
  return <section className="bg-brand-green py-24 px-6 relative overflow-hidden" data-id="element-532">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-533">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-534"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-beige rounded-full blur-3xl" data-id="element-535"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-536">
        {/* Header */}
        <FadeIn data-id="element-537">
          <div className="text-center mb-16" data-id="element-538">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6" data-id="element-539">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-540" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-541">
              🎁 ACCESO A BONOS PREMIUM (INCLUIDOS)
            </h2>
            <p className="text-lg md:text-xl text-white/60 max-w-3xl mx-auto leading-relaxed" data-id="element-542">
              Además de la guía principal, recibirás herramientas prácticas
              diseñadas para ayudarte a dominar Amazon FBM desde el primer día y
              comenzar a generar ingresos con bases sólidas.
            </p>
          </div>
        </FadeIn>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14" data-id="element-543">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-544">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col hover:border-brand-gold/30 transition-colors" data-id="element-545">
                {/* Image */}
                <div className="p-5 pb-0" data-id="element-546">
                  <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-xl object-contain" data-id="element-547" />
                </div>

                {/* Content */}
                <div className="p-8 pt-5 flex flex-col flex-1" data-id="element-548">
                  {/* Badge */}
                  <span className="inline-block w-fit text-xs font-bold tracking-wider text-brand-gold bg-brand-gold/10 border border-brand-gold/30 px-3 py-1 rounded-full mb-3" data-id="element-549">
                    {bonus.badge}
                  </span>

                  {/* Title */}
                  <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-550">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-white/50 text-sm md:text-base leading-relaxed mb-6" data-id="element-551">
                    {bonus.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 mb-6" data-id="element-552">
                    {bonus.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-553">
                        <CheckCircle2 className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-554" />
                        <span className="text-sm text-white/80 font-medium" data-id="element-555">
                          {feature}
                        </span>
                      </div>)}
                  </div>

                  {/* Value */}
                  <div className="mt-auto pt-5 border-t border-white/10 flex items-center justify-between" data-id="element-556">
                    <span className="text-xs uppercase tracking-wider text-white/50 font-semibold" data-id="element-557">
                      Valor real
                    </span>
                    <span className="text-2xl font-bold text-brand-gold" data-id="element-558">
                      {bonus.value}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Total value footer */}
        <FadeIn delay={0.5} data-id="element-559">
          <div className="text-center bg-white/5 border border-brand-gold/30 rounded-2xl px-8 py-10 max-w-3xl mx-auto" data-id="element-560">
            <Sparkles className="w-8 h-8 text-brand-gold mx-auto mb-4" data-id="element-561" />
            <p className="text-sm uppercase tracking-widest text-white/60 mb-2 font-semibold" data-id="element-562">
              Valor total de los bonos premium
            </p>
            <p className="text-4xl md:text-5xl font-bold text-brand-gold mb-2" data-id="element-563">
              MÁS DE $190 EN VALOR REAL
            </p>
            <p className="text-base md:text-lg text-white/70 mt-3" data-id="element-564">
              Todo incluido en tu acceso al curso Amazon FBM
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}